module.exports = __webpack_public_path__ + "static/media/intro1.19e9ba7a.jpg";